// Lớp phủ của hộp thoại / ngăn kéo (Dialog, Sheet – ConfirmDialog dựng trên Dialog): chỉ lớp mở ĐẦU TIÊN làm tối nền,
// lớp mở sau (hộp chồng lên hộp) trong suốt – không tối dần theo số hộp đang mở (chủ dự án 15/10/2026).
// Đếm toàn cục thay vì context: hộp xác nhận thường đặt cạnh, không lồng trong hộp mẹ ở cây React.
import { useLayoutEffect, useState } from 'react'

let openOverlays = 0

/** true = lớp phủ đầu tiên (được tô tối); gọi trong component lớp phủ – chỉ mount khi hộp mở */
export function useIsBaseOverlay(): boolean {
  const [base, setBase] = useState(true)
  // quyết định trong layout effect (chạy theo thứ tự cây, trước khi vẽ) – nhiều hộp mở cùng một lượt render vẫn chỉ một hộp tối
  useLayoutEffect(() => {
    setBase(openOverlays === 0)
    openOverlays += 1
    return () => {
      openOverlays -= 1
    }
  }, [])
  return base
}
